const BreadcrumbChevron = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.72 9 4 8.293 6.56 6 4 3.707 4.72 3 8 6 4.72 9z" fill="#000" />
    </svg>
)

export default BreadcrumbChevron;